<template lang='pug'>
  .bf-input.component
    bf-flex.container.centered
      span.icon
        slot( name='icon' )
      span.input-container
        slot
          input( type='text' )
        label( v-show='text' )
          slot( name='label' )
      span.reveal
        slot( name='reveal')

</template>

<script>
  export default {
    name: 'bf-input',

    props: [ 'text' ]
  }
</script>

<style scoped lang="stylus">
  .bf-input .container
    margin 10px 0
    height 35px
    background rgb( 240 240 240 )
    padding 8px 10px
    border-radius 5px
    &.remind
      border 1.5px solid red

  .bf-input.basic.invalid .container
    border-color red

  .input-container
    flex-grow 1
    margin-left 8px

  .icon
    width 16px
    height 16px
    font-size 1.5em
    margin-right 4px
    flex-grow 0
    
  .reveal
    width 30px
    padding-left 10px

  .bf-input.material
    .icon
      width auto
      height auto
      margin-right 2px

// Specific Styles //

  .bf-input.basic
    .container
      border-radius 5px
      box-shadow none
      background rgba( 240 240 240 .25 )
      border 1px solid rgba( 0 0 0 .1 )
      margin 0
      padding 0px 8px
      width auto
      &:focus-within
        border-color orange

    .input-container
      margin-left 0
    .icon
      display none

  .bf-input.block
    box-sizing border-box
    input, textarea
      width 100%
      display block


  .bf-input.clear
    background 0
    border 1px solid rgba( 0 0 0 .1 )

  .bf-input.thin
    padding: 5px 12px

  .bf-input.centered
    .input-container
      flex-grow 0

  .bf-input.icon-right .container
    flex-direction row-reverse
    .icon
      font-size 1em
      margin 3.5px 24px 0px 12px
      font-weight bold

  .bf-input.phone
    padding-left 12px
    padding-top 6px
    padding-bottom 6px

  .bf-input.phone-input
    margin 0 16px
    min-width 268px
    position relative
    >>> .tel-input
      position absolute
      margin 0 auto
      border 0
      top 3px
      @media(min-width: 420px)
        top 8px
        left 68px
      @media(min-width: 360px)
        top 7px
      input
        padding 0

  .bf-input.labeled
    &.text-area
      .container
        height 128px
        box-sizing border-box
        >>> textarea
          z-index 1
          width 100%
          top 18px
          padding-top 0
          resize none
          box-sizing border-box
    .container
      height 42px
      padding 0 24px
      
    >>> label
      position relative
      bottom 22px
      opacity 0
      font-size .96em
      font-weight bold
    >>> input, >>> textarea
      padding 0 24px
      padding-top 32px
      position absolute
      left 0
      top -18px
      box-sizing: border-box;
      &:focus, &:active
        &::placeholder
          opacity 1
          transition all 480ms
          transform scale(.96) translateY(-37px)
          opacity .75
          transform-origin left
          color var(--clr-blue)
      &:focus + label
        opacity .75
        top -34px
</style>
